<template>
    <div class="properties-volume-view">
        <div>
            <el-card>
                <div class="properties-volume-view__item">
                    <span>{{ translate('volume_max') }}</span>
                    <span>{{ report.max_volume }}</span>
                </div>
            </el-card>
        </div>
        <div>
            <el-card>
                <div class="properties-volume-view__item">
                    <span>{{ translate('volume_average') }}</span>
                    <span>{{ report.average_volume }}</span>
                </div>
            </el-card>
        </div>
        <div>
            <el-card>
                <div class="properties-volume-view__item">
                    <span>{{ translate('volume_min') }}</span>
                    <span>{{ report.min_volume}}</span>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PropertiesVolumePy',
    methods: {
        translate(key) {
            const base = 'contrato_rastreabilidade.messages.view';
            return this.$t(`${base}.${key}`);
        }
    },
    computed: {
        ...mapGetters('traceabilityContractModule', {
            report: 'getReport'
        })
    }
};
</script>
<style scoped lang="scss">
.properties-volume-view {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    .properties-volume-view__item {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 500;
        span:first-child {
            font-weight: 500;
            color: #3B3B3B;
        }

        span:last-child {
            font-weight: 400;
            color: #00413C;
        }
    }
}
</style>
